import React from 'react';
import { Link } from 'react-router-dom';
import { FaYoutube, FaInstagram } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import { CONTACT_EMAIL, SOCIAL_LINKS } from '../../constants';
import { PROGRAMS } from '../../constants/programs';

const linkClassName =
  'block text-sm md:text-base text-canvas hover:text-gold transition-colors py-1';

export default function SiteFooter({ className = '' }) {
  return (
    <footer
      className={`bg-forest text-canvas py-8 md:py-12 px-4 sm:px-6 lg:px-8 mt-auto ${className}`}
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-x-4 gap-y-8 md:gap-8">
        <div className="col-span-2 md:col-span-1 lg:col-span-2">
          <h2 className="font-display font-bold text-gold text-base md:text-lg mb-2">
            Dars Initiative
          </h2>
          <p className="text-sm md:text-base text-canvas leading-snug">
            501(c)(3) Nonprofit — Service
          </p>
          <p className="text-sm md:text-base text-canvas leading-snug mt-2">
            1946 Lebanon Rd
            <br />
            Lawrenceville, GA 30043
          </p>
          <p className="text-sm md:text-base text-canvas/90 leading-snug mt-4 md:mt-5">
            Dars Initiative is a community-driven nonprofit dedicated to empowering individuals
            through educational programming, volunteer-led service initiatives, and inclusive
            outreach that provides support and resources to people of all backgrounds.
          </p>
        </div>

        <div>
          <h3 className="text-base font-semibold text-gold mb-2">Organization</h3>
          <nav aria-label="Organization links">
            <ul className="space-y-2">
              <li>
                <Link to="/about" className={linkClassName}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/impact" className={linkClassName}>
                  Impact Report
                </Link>
              </li>
              <li>
                <Link to="/events" className={linkClassName}>
                  Events
                </Link>
              </li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`} className={linkClassName}>
                  {CONTACT_EMAIL}
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div>
          <h3 className="text-base font-semibold text-gold mb-2">Programs</h3>
          <nav aria-label="Programs links">
            <ul className="space-y-2">
              <li>
                <Link to="/programs" className={linkClassName}>
                  All Programs
                </Link>
              </li>
              {PROGRAMS.slice(0, 5).map((p) => (
                <li key={p.slug}>
                  <Link to={`/programs/${p.slug}`} className={linkClassName}>
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="flex flex-col">
          <h3 className="text-base font-semibold text-gold mb-2">Get Involved</h3>
          <nav aria-label="Get involved links" className="flex-1">
            <ul className="space-y-2">
              <li>
                <Link to="/volunteer" className={linkClassName}>
                  Volunteer
                </Link>
              </li>
              <li>
                <Link to="/blog" className={linkClassName}>
                  Community Blog
                </Link>
              </li>
              <li>
                <Link to="/donate" className={linkClassName}>
                  Donate
                </Link>
              </li>
            </ul>
          </nav>
          <div className="flex gap-4 mt-3 md:mt-4">
            <a
              href={SOCIAL_LINKS.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center text-lg text-canvas hover:text-gold transition-all"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href={SOCIAL_LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center text-lg text-canvas hover:text-gold transition-all"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href={SOCIAL_LINKS.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center text-lg text-canvas hover:text-gold transition-all"
              aria-label="TikTok"
            >
              <SiTiktok />
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-6 pt-6 md:mt-8 md:pt-8 border-t border-canvas/25 text-center text-sm md:text-base text-canvas">
        <p>
          &copy; Dars Initiative 2026. We are a 501(c)(3) organization. All donations are tax
          deductible. Our EIN is 33-4806534.
        </p>
      </div>
    </footer>
  );
}
